<template>
    <div class="page">
        <panel
            ref="panel"
            :wapTitle="name"
            :appLink="appLink"
            :spreadID="'0'"
            :showNav="true"
            :showLogin="false"
            :isDetail="true"
            @gotoApp="gotoApp"
            :isApp="false"
        ></panel>
        <div class="auctionInfos">
            <template v-for="(item, index) in info">
                <dl :key="index">
                    <router-link
                        :to="{
                            path:
                                '/organ/' + item.organCode + waterLink,
                        }"
                        v-if="item.type == 'company'"
                    >
                        <dt>{{ item.label }}</dt>
                        <dd>
                            <p class="wenzi">{{ item.text }}</p>
                            <span class="icon"></span>
                            <span class="icon detailIcon"></span>
                        </dd>
                    </router-link>
                    <a
                        href="javascript:;"
                        class="gotoAppBtn"
                        :data-url="appLink"
                        v-else-if="item.name == 'previewPlace'"
                    >
                        <dt>{{ item.label }}</dt>
                        <dd @click="gotoApp">
                            <p class="wenzi">{{ item.text }}</p>
                            <span class="icon"></span>
                            <span class="icon addressIcon"></span>
                        </dd>
                    </a>
                    <a
                        href="javascript:;"
                        class="gotoAppBtn"
                        :data-url="appLink"
                        v-else-if="item.name == 'Place'"
                    >
                        <dt>{{ item.label }}</dt>
                        <template v-if="item.otherAddressArray">
                            <dd v-for="(m,k) in item.otherAddressArray" :key="k"
                                @click="gotoApp">
                                <p class="wenzi">{{ m }}</p>
                                <span class="icon"></span>
                                <span class="icon addressIcon"></span>
                            </dd>
                        </template>
                        <template v-else>
                            <dd @click="gotoApp">
                                <p class="wenzi">{{ item.text }}</p>
                                <span class="icon"></span>
                                <span class="icon addressIcon"></span>
                            </dd>
                        </template>
                    </a>
                    <a
                        href="javascript:;"
                        class="gotoAppBtn"
                        :data-url="appLink"
                        @click="gotoApp"
                        v-else-if="item.type == 'topart50'"
                    >
                        <dt>{{ item.label }}</dt>
                        <dd>
                            <p class="wenzi">{{ item.text }}</p>
                        </dd>
                    </a>
                    <template v-else>
                        <dt>{{ item.label }}</dt>
                        <dd>
                            <p class="wenzi">{{ item.text }}</p>
                        </dd>
                    </template>
                </dl>
            </template>
        </div>
        <div class="rules" @click="openPop" v-if="msg">
            拍卖规则<span class="detailIcon"></span>
        </div>
        <p class="tips">*落槌价仅供参考，所有成交以拍卖公司提供的为准</p>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getWXConfig } from "@/assets/js/weixinShare";
import panel from "@/views/preview/component/panel.vue";
import DownLoadApp from "@/components/common/downloadApp";
import { sessionDetail } from "@/api/auction";
import watermark from "@/components/common/watermark";
import {Toast} from "vant";

export default {
    name: "sessionDetail",
    data() {
        return {
            showWater: false,
            waterLink: "",
            info: {},
            // info: this.$route.query.info,
            // name: this.$route.query.name,
            name: "",
            flag: false,
            showPop: false,
            msg: "",
            param: {
                sessionCode: "",
                only_meta: 1,
            },
            keyWorld: {
                sessionCode: "",
                show: 0,
            },
            appLink: "/2/3/" + this.$route.query.sessionCode,
        };
    },
    created() {
        if (
            (this.$route.query.from && this.$route.query.from == 1) ||
            this.$route.query.from == 2
        ) {
            this.showWater = true;
            this.waterLink = "?from="+this.$route.query.from;
        }
        this.getsessionDetailList();
    },
    components: {
        panel,
        DownLoadApp,
        watermark,
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageSession/getIsLoadIng",
            getData: "pageSession/getData",
        }),
    },
    methods: {
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        goBack() {
            if (document.referrer) {
                window.location.href = document.referrer
            } else if(window.history.state) {
                this.$router.back()
            }else if(this.$route.query.fromlink){
                window.location.href=decodeURIComponent(this.$route.query.fromlink)
            } else{
                this.$router.push({ path: "/" });
            }
        },
        ...mapActions({
            getsessionDetail: "pageSession/getsessionDetail",
        }),
        openPop() {
            this.$router.push({
                name:'sessionRule',
                query:{
                    sessionCode:this.$route.query.sessionCode,
                    from:this.$route.query.from
                },
            });
        },
        closePop() {
            this.showPop = false;
        },
        filteData() {
            // 微信分享+title
            let dome = this.$store.state["pageSession"]["data"];
            document.title = dome.meta ? dome.meta.title : "";
            let head = document.getElementsByTagName("head");
            if (!document.querySelector("meta[name=description]")) {
                let meta = document.createElement("meta");
                meta.name = "description";
                meta.content = dome.meta ? dome.meta.description : "";
                head[0].appendChild(meta);
            } else {
                document
                    .querySelector("meta[name=description]")
                    .setAttribute(
                        "content",
                        dome.meta ? dome.meta.description : ""
                    );
            }
            window.AFedWxShareData = {
                title: dome.meta ? dome.meta.shareTitle : "",
                imgUrl:
                    dome.meta.pic ||
                    "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                desc: dome.meta.description || "",
                link: window.location.href,
            };
            getWXConfig(window.AFedWxShareData);
        },
        // 接口
        getsessionDetailList() {
            this.keyWorld.sessionCode = this.$route.query.sessionCode;
            if (this.$route.query.from && this.$route.query.from == 1) {
                this.keyWorld.show = 1;
            }
            let that = this
            sessionDetail(this.keyWorld).then((res) => {
                if (res.code == 0) {
                    this.info = res.data.detailExtraInfo;
                    this.name = res.data.name;
                    this.msg = res.data.rule;
                }else{
                    Toast({
                        message: '该内容不存在～',
                        duration:2000,
                        onClose:function (){
                            that.$router.push({
                                path:'/',
                                query:{
                                    from:that.$route.query.from
                                }
                            })
                        }
                    })
                }
            });
        },
    },
    mounted() {
        if (this.$route.query.from && this.$route.query.from == "cloud") {
            this.showWater = true;
            this.waterLink = "&from=cloud";
        }
        if (!this.getIsLoadIng) {
            this.param.sessionCode = this.$route.query.sessionCode;
            this.param.only_meta = 1;
            this.getsessionDetail([
                this.param,
                () => {
                    this.filteData();
                },
            ]);
        } else if (this.getIsLoadIng) {
            this.filteData();
        }
    },
    asyncData({ store, route }) {
        let dataJSON = {
            sessionCode: route.query.sessionCode,
            only_meta: 1,
        };
        return store.dispatch("pageSession/getsessionDetail", [
            dataJSON,
            null,
            () => {},
        ]);
    },
};
</script>

<style scoped>
@import url("../../assets/css/reset.css");
@import url("../../assets/css/swiper.css");
.greenHeader {
    background: #35bd7d;
}
.greenHeader .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_white@2x.png) no-repeat;
    background-size: cover;
}

.page {
    width: 18.75rem;
    margin: 0 auto;
}
.auctionInfos {
    padding: 0 0.75rem;
    background: #ffffff;
}
.auctionInfos a{
    display:block;
}
.auctionInfos dl {
    font-size: 0.75rem;
    line-height: 1.05rem;
    color: #333333;
    overflow: hidden;
    border-bottom: 0.05rem solid #dddee3;
    /* white-space: nowrap; */
}
.auctionInfos dl:last-child{border-bottom: 0;}
.auctionInfos dt {
    width: 3.75rem;
    float: left;
    color: #999999;
    white-space: nowrap;
    padding: 0.65rem 0 0.7rem;
}
.auctionInfos dd {
    margin-left: 3.75rem;
    padding: 0.65rem 0.8rem 0.7rem;
    position: relative;
}
.auctionInfos dd .wenzi {
    width: 12.4rem;
    word-wrap: break-word;
    word-break: break-all;
    word-break: normal;
}
.auctionInfos .orgDl dt {
    width: 5.25rem;
}
.auctionInfos .orgDl dd {
    margin-left: 5.25rem;
}
.auctionInfos dd .icon {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    top: 50%;
    right: 0;
    margin-top: -0.4rem;
    background-repeat: no-repeat;
    background-size: cover;
}
.auctionInfos dd .detailIcon {
    background-image: url(../../assets/img/icon_detial_arrow.png);
}
.auctionInfos dd .addressIcon {
    background-image: url(../../assets/img/icon_address.png);
}
.rules {
    margin-top: 0.25rem;
    height: 2.6rem;
    background: #ffffff;
    padding: 0 0.75rem;
    font-size: 0.8rem;
    line-height: 2.6rem;
    color: #27282d;
    position: relative;
}
.rules .detailIcon {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    right: 0.75rem;
    top: 0.8rem;
    background: url(../../assets/img/icon_detial_arrow.png) no-repeat;
    background-size: cover;
}
.tips {
    padding: 0 0.75rem;
    margin-top: 0.25rem;
    font-size: 0.6rem;
    color: #dd2815;
    line-height: 0.85rem;
}
article {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    transform: translateX(100%);
    z-index: -1;
    background-color: #fff;
    transition: 0.2s transform ease-in-out;
}
article.openExplain {
    transform: translateX(0);
    z-index: 100;
}
.header {
    height: 2.2rem;
    background: #ffffff;
    margin-top: 6rem;
}
.header h3 {
    margin-left: 2.2rem;
    margin-right: 2.2rem;
    text-align: center;
    font-size: 0.9rem;
    line-height: 2.2rem;
    color: #27282d;
}
.header .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_light@2x.png) no-repeat;
    background-size: cover;
}
.explain {
    padding: 1.5rem 0.75rem 3.75rem;
    background-color: #fff;
}
.explain h1 {
    line-height: 3rem;
    font-size: 1rem;
    text-align: center;
}
.explain h2 {
    font-size: 0.65rem;
    color: #323232;
    padding: 1rem 0rem 0.25rem;
}
.explain li {
    line-height: 0.9rem;
    font-size: 0.6rem;
    color: #646464;
}
.explain p {
    margin-bottom: 0.25rem;
    font-size: 0.6rem;
    color: #646464;
}
.explain img {
    max-width: 100%;
}
</style>